import StaticRenderer from './static/StaticRenderer';
import SelectListRenderer from './question/SelectListRenderer';

export const RENDERERS = {
  select_list: SelectListRenderer,
  static: StaticRenderer,
};

export function getRenderer(rendererName) {
  if (!rendererName) return null;
  return RENDERERS[rendererName] ?? null;
}
